import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './config/plugins'
import VueLazyload from 'vue-lazyload'
import echarts from 'echarts'
import 'echarts/map/js/china'
import './utils/directives.js'
import cal from './utils/calculation';
import socket from './assets/js/mysocket'
import AMap from 'vue-amap';
import vueEsign from 'vue-esign'
import WebIM from './utils/WebIM';
// import "video.js/dist/video-js.css"; // 引入video.js的css
// import hls from "videojs-contrib-hls"; // 播放hls流需要的插件

Vue.prototype.sendMsg = socket.sendMsg
Vue.prototype.cal = cal //小数点精度丢失处理 
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false;

// 须在高德 JS API 脚本加载前配置（与控制台「安全密钥」一致）
window._AMapSecurityConfig = {
  securityJsCode: 'eeb01b2e22bfc086ad3deaab7b3c7cd8'
}

Vue.use(AMap);
Vue.use(vueEsign);
// Vue.use(hls);
AMap.initAMapApiLoader({
  // 高德 Web 端(JS API) Key（可数点-新后台管理）
  key: '422df50a540cb7e03485cc0bb62dac13',
 // key: '01b48c4c3849357936137213bdd8ea42',
 // key:'284183fa0503d47fdec4855c8a0fabcf',
  //key:'d4c6187f4bd60be280c27489ded5fc41',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation', 'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView',
    'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.PolygonEditor',
		'AMap.Geocoder','AMap.Driving','AMap.MoveAnimation','AMap.GraspRoad'
  ],
  // vue-amap@0.5 与 JS API 2.0 的 callback 时机不兼容，会在 amapInitComponent 中报 AMap is not defined
  v: '1.4.15'
});

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/404.jpg'),
  loading: require('./assets/loading.svg'),
  attempt: 1,
  listenEvents: ['scroll']
})

Vue.prototype.AMapObj=AMap;
Vue.prototype.$envobj = new Vue();



new Vue({
  router,
  store,
	WebIM,
  data: function() {
    return {
      lingdang: 0,
      lingdangAudio: 'https://v3kosskeydeal.api.bt.besp.cn/27d3975776efb628beb13307bbc359e3.mp4',//推送异常
      lingTiShiAudio: 'https://v3kosskeydeal.api.bt.besp.cn/d5d2f4263c75b863418d4fe4a461fbb9.mp4',//模糊订单推送
      InterveneAudio: 'https://v3kosskeydeal.api.bt.besp.cn/a928322c5c692b351e6036778f5ef2ac.mp4',    //有订单异订单未点链接推送
      InterveneAudios: 'https://v3kosskeydeal.api.bt.besp.cn/e161c39e492726d1ac01209c18c1de44.mp4',  //空驶补偿
      subscribe: 'https://v3kosskeydeal.api.bt.besp.cn/cf1caf4a6bf1fbc84f338870df824043.mp4',  //预约单提示
      orderyc:'https://v3kosskeydeal.api.bt.besp.cn/a289076dc266283970315a63b9567655.mp4',//订单异常
      postData:{}
    }
  },
  render: h => h(App)
}).$mount('#app');

import PublicCss from './css/main.css'
Vue.use(PublicCss)
